import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason.tsx';
import { getComponentsPageRequest } from '../../state/actions.tsx';
import { get as getAnalyticsData } from '../../state/analytics/selectors.tsx';
import { patchQuery } from '../../state/query/actions.tsx';
import { getCurrentPage } from '../../state/query/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { getTotalPages } from '../../state/selectors.tsx';
import PaginatorView from './view.tsx';

const mapStateToProps = (state: State) => ({
	currentPage: getCurrentPage(state),
	totalPages: getTotalPages(state),
	analyticsData: getAnalyticsData(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onPageChange: (number: number) => {
		dispatch(patchQuery({ page: number }));
		return dispatch(
			getComponentsPageRequest({
				page: number,
				initiatedBy: FETCH_COMPONENTS_REASON.VIEW,
			}),
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(PaginatorView);
